import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import BookingDetails from '../Dashboard/BookingDetails/BookingDetails';
import {monthData, tabData, monthToShow} from '../Dashboard/data';
import ProgressGraph from './ProgressGraph/ProgressGarph';
import SelectMonth from '../Dashboard/SelectMonth/SelectMonth';
import {getLoyaltyDashboardData} from '../../../../store/actions/thunk';
import {numFormatter, numberWithCommas} from '../../../../utils/utils';
import {monthsNoDataXaxis} from '../../../../constants/dashboardConfig.js';
import * as S from './ProgressContainer.styles';
//import useWindowSize from '../useWindowSize';
import NoDetails from './NoDetails/NoDetails';
import mailBox from '../../assets/mailbox.png';

const DashboardV2 = ({
  handleViewDetails,
  noDetails,
  responseData,
  hotelTravelCompletedAmount,
  hotelYetToTravelAmount,
  setResponseData,
  graphTemplateData,
}) => {
  const curMonth = new Date().getMonth();
  const winSize = window.screen.width;
  const dispatch = useDispatch();
  const [monthlyGMVMap, setMonthlyGMVMap] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [upcomingData, setUpcomingdData] = useState([]);
  const [incentivesData, setIncentivesdData] = useState([]);
  const [noData, setNoData] = useState(true);

  useEffect(() => {
    if (responseData?.monthGmvMap) {
      const monthMap = [];
      let count = 0;
      for (const monthData in responseData?.monthGmvMap) {
        let monthObject = {
          name: monthData,
          travelCompleted: responseData?.monthGmvMap[monthData]?.completedAmount,
          travelPendingOne: responseData?.monthGmvMap[monthData]?.pendingAmount,
          heroIcon:
            responseData?.monthGmvMap[monthData]?.currentTier === 3
              ? 'https://promos.makemytrip.com/appfest/2x/DT-HeroStar.webp'
              : responseData?.monthGmvMap[monthData]?.currentTier === 2
              ? 'https://assets-gos3.goibibo.com/myp_heroStar-1685087276.svg'
              : responseData?.monthGmvMap[monthData]?.currentTier === 1
              ? 'https://assets-gos3.goibibo.com/myp_hero-1685087265.svg'
              : '',
          hotelTravelCompleted: responseData?.monthGmvMap[monthData]?.hotelsCompletedAmount,
          travelPendingTwo: responseData?.monthGmvMap[monthData]?.hotelsPendingAmount,
        };

        if (count < 3) monthMap.push(monthObject);
        count++;
      }
      setMonthlyGMVMap(monthMap.length > 0 ? monthMap : monthlyGMVMap);
      setNoData(false);
    } else {
      setNoData(true);
    }
    if (responseData?.completed) {
      setCompletedData(responseData.completed);
    }
    if (responseData?.upcoming) {
      setUpcomingdData(responseData.upcoming);
    }
    if (responseData?.incentive) {
      setIncentivesdData(responseData?.incentive);
    }
  }, [responseData]);

  const successCallback = data => {
    if (data?.completed) {
      for (let completedTravel = 0; completedTravel < data.completed.length; completedTravel++) {
        let travelDay = new Date(data.completed[completedTravel].travelEndDate).toLocaleDateString(
          'en-US',
        );
        //console.log(day);
        data.completed[completedTravel].travelStartDate = travelDay;
        let bookingDay = new Date(data.completed[completedTravel].bookingDate).toLocaleDateString(
          'en-US',
        );
        data.completed[completedTravel].bookingDate = bookingDay;
      }
    }

    if (data?.upcoming) {
      for (let upcomingTravel = 0; upcomingTravel < data.upcoming.length; upcomingTravel++) {
        let travelDay = new Date(data.upcoming[upcomingTravel].travelEndDate).toLocaleDateString(
          'en-US',
        );
        //console.log(day);
        data.upcoming[upcomingTravel].travelStartDate = travelDay;
        let bookingDay = new Date(data.upcoming[upcomingTravel].bookingDate).toLocaleDateString(
          'en-US',
        );
        data.upcoming[upcomingTravel].bookingDate = bookingDay;
      }
    }

    if (data?.incentive) {
      for (let incentiveCounter = 0; incentiveCounter < data.incentive.length; incentiveCounter++) {
        let travelDay = new Date(data.incentive[incentiveCounter].creditDate).toLocaleDateString(
          'en-US',
        );
        //console.log(day);
        data.incentive[incentiveCounter].creditDate = travelDay;
      }
    }

    setResponseData(data);
  };

  const errorCallback = data => {
    console.log(data);
  };

  useEffect(() => {
    if (responseData?.monthGmvMap) {
      const monthMap = [];
      let count = 0; //TODO: FIX THIS LATER ONCE LOYALTY CHANGES ARE LIVE
      for (const monthData in responseData?.monthGmvMap) {
        let monthObject = {
          name: monthData,
          travelCompleted: responseData?.monthGmvMap[monthData]?.completedAmount,
          travelPendingOne: responseData?.monthGmvMap[monthData]?.pendingAmount,
          heroIcon:
            responseData?.monthGmvMap[monthData]?.currentTier === 3
              ? 'https://promos.makemytrip.com/appfest/2x/DT-HeroStar.webp'
              : responseData?.monthGmvMap[monthData]?.currentTier === 2
              ? 'https://assets-gos3.goibibo.com/myp_heroStar-1685087276.svg'
              : responseData?.monthGmvMap[monthData]?.currentTier === 1
              ? 'https://assets-gos3.goibibo.com/myp_hero-1685087265.svg'
              : '',
          hotelTravelCompleted: responseData?.monthGmvMap[monthData]?.hotelsCompletedAmount,
          travelPendingTwo: responseData?.monthGmvMap[monthData]?.hotelsPendingAmount,
        };

        if (count < 3) monthMap.push(monthObject);
        count++;
      }
      setMonthlyGMVMap(monthMap.length > 0 ? monthMap : monthlyGMVMap);
      setNoData(false);
    } else {
      setNoData(true);
    }
    if (responseData?.completed) {
      setCompletedData(responseData.completed);
    }
    if (responseData?.upcoming) {
      setUpcomingdData(responseData.upcoming);
    }
    if (responseData?.incentive) {
      setIncentivesdData(responseData?.incentive);
    }
  }, [responseData]);

  return (
    <S.Prgs>
      {monthlyGMVMap?.length == 0 && (
        <NoDetails
          icon={mailBox}
          heading="Your journey to become a hero starts here!"
          cta={'Book Now'}
        />
      )}
      {
        <S.PrgsLeft>
          <ProgressGraph
            graphTemplateData={graphTemplateData}
            handleViewDetails={handleViewDetails}
            graphData={monthlyGMVMap}
            monthGmv={responseData?.completedGmv ? responseData?.completedGmv : 0}
            mileStoneAmount={responseData?.milestoneAmount ? responseData?.milestoneAmount : 0}
            totalBookingAmount={
              responseData?.totalBookingAmount ? responseData?.totalBookingAmount : 0
            }
            hotelTravelCompletedAmount={hotelTravelCompletedAmount ? hotelTravelCompletedAmount : 0}
            hotelYetToTravelAmount={hotelYetToTravelAmount ? hotelYetToTravelAmount : 0}
            internationalSpends={responseData?.internationalSpends || 0}
            internationSpendsCallout={responseData?.internationalSpendsCallOut || {}}
          />
        </S.PrgsLeft>
      }
      {winSize > 767 && (
        <S.PrgsRight>
          <S.PrgsRightHdr>
            <h2>Booking Details</h2>
            <SelectMonth
              data={monthData}
              monthToShow={graphTemplateData?.tableData?.monthData}
              setData={setResponseData}
            />
          </S.PrgsRightHdr>
          <BookingDetails
            tabData={tabData}
            completedData={completedData}
            upcomingData={upcomingData}
            incentivesData={incentivesData}
          />
        </S.PrgsRight>
      )}
    </S.Prgs>
  );
};

export default DashboardV2;
